import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  :root {
    --primary-bg: #000000;
    --secondary-bg: #4B0000;
    --card-bg: rgba(75, 0, 0, 0.85);
    --header-bg: rgba(75, 0, 0, 0.9);
    --header-scrolled-bg: rgba(139, 0, 0, 0.95);
    --footer-bg: #000000;

    --primary-text: #FFFFE0;
    --secondary-text: #FFD700;
    --heading-text: #FFD700;

    --accent-color: #FF4500;
    --accent-hover: #FF8C00;
    --secondary-accent: #FFA500;
    --glow-color: rgba(255, 69, 0, 0.5);

    --border-color: rgba(255, 69, 0, 0.2);
    --border-hover-color: rgba(255, 69, 0, 0.5);
    --shadow-color: rgba(255, 69, 0, 0.15);
    --strong-shadow-color: rgba(255, 69, 0, 0.3);

    --font-primary: 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
    
    --font-code: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;

    --header-height: 70px;
    --border-radius: 10px;
    --transition-speed: 0.3s;
    --transition-speed-fast: 0.2s;
    --transition-speed-slow: 0.5s;
    --transition-effect: cubic-bezier(0.25, 0.8, 0.25, 1);
  }

  *,
  *::before,
  *::after {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;
    font-size: 16px;
    scrollbar-width: thin;
    scrollbar-color: var(--accent-color) var(--primary-bg);
  }

  @media screen and (min-width: 768px) {
    ::-webkit-scrollbar {
        width: 8px;
    }
    ::-webkit-scrollbar-track {
        background: var(--primary-bg);
    }
    ::-webkit-scrollbar-thumb {
        background-color: var(--accent-color);
        border-radius: 10px;
        border: 2px solid var(--primary-bg);
    }
    ::-webkit-scrollbar-thumb:hover {
        background-color: var(--accent-hover);
    }
  }

  body {
    font-family: var(--font-primary);
    background-color: var(--primary-bg);
    color: var(--primary-text);
    line-height: 1.7;
    overflow-x: hidden;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  code {
    font-family: var(--font-code);
  }

  a {
    color: var(--accent-color);
    text-decoration: none;
    transition: color var(--transition-speed) var(--transition-effect);
  }

  a:hover {
    color: var(--accent-hover);
  }

  h1, h2, h3, h4, h5, h6 {
    color: var(--heading-text);
    font-weight: 600;
    line-height: 1.3;
    margin-bottom: 1rem;
    text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.3);
  }

  h1 { font-size: clamp(2.5rem, 5vw, 3.5rem); }
  h2 { font-size: clamp(2rem, 4vw, 2.5rem); }
  h3 { font-size: clamp(1.3rem, 3vw, 1.6rem); }
  p { margin-bottom: 1.2rem; color: var(--secondary-text); font-size: clamp(0.95rem, 1.5vw, 1.05rem); }

  img, video {
    max-width: 100%;
    height: auto;
    display: block;
    will-change: transform;
  }

  section {
    padding: 7rem 6%;
    overflow: hidden;
    position: relative;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  }

  section:last-of-type {
    border-bottom: none;
  }

  .btn {
    display: inline-block;
    padding: 1rem 2.5rem;
    background: var(--accent-color);
    color: var(--primary-bg);
    font-weight: 600;
    border-radius: var(--border-radius);
    transition: background var(--transition-speed) var(--transition-effect),
                color var(--transition-speed) var(--transition-effect),
                transform var(--transition-speed) var(--transition-effect),
                box-shadow var(--transition-speed) var(--transition-effect);
    border: 2px solid var(--accent-color);
    cursor: pointer;
    text-transform: uppercase;
    letter-spacing: 1.5px;
    margin-top: 1.5rem;
    box-shadow: 0 5px 15px rgba(0, 255, 204, 0.2);
  }

  .btn:hover {
    background: transparent;
    color: var(--accent-color);
    transform: translateY(-5px) scale(1.03);
    box-shadow: 0 10px 25px var(--strong-shadow-color);
  }

  @import url('https://fonts.googleapis.com/css2?family=Rajdhani:wght@300;400;500;600;700&family=Orbitron:wght@400;500;600;700&display=swap');
  
  :root {
    --primary-bg: #000000;
    --secondary-bg: #4B0000;
    --card-bg: rgba(75, 0, 0, 0.85);
    --header-bg: rgba(75, 0, 0, 0.9);
    --header-scrolled-bg: rgba(139, 0, 0, 0.95);
    --footer-bg: #000000;

    --primary-text: #FFFFE0;
    --secondary-text: #FFD700;
    --heading-text: #FFD700;

    --accent-color: #FF4500;
    --accent-hover: #FF8C00;
    --secondary-accent: #FFA500;
    --glow-color: rgba(255, 69, 0, 0.5);

    --border-color: rgba(255, 69, 0, 0.2);
    --border-hover-color: rgba(255, 69, 0, 0.5);
    --shadow-color: rgba(255, 69, 0, 0.15);
    --strong-shadow-color: rgba(255, 69, 0, 0.3);

    --font-primary: 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
    
    --font-code: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;

    --header-height: 70px;
    --border-radius: 10px;
    --transition-speed: 0.3s;
    --transition-speed-fast: 0.2s;
    --transition-speed-slow: 0.5s;
    --transition-effect: cubic-bezier(0.25, 0.8, 0.25, 1);
  }

  *,
  *::before,
  *::after {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;
    font-size: 16px;
    scrollbar-width: thin;
    scrollbar-color: var(--accent-color) var(--primary-bg);
  }

  @media screen and (min-width: 768px) {
    ::-webkit-scrollbar {
        width: 8px;
    }
    ::-webkit-scrollbar-track {
        background: var(--primary-bg);
    }
    ::-webkit-scrollbar-thumb {
        background-color: var(--accent-color);
        border-radius: 10px;
        border: 2px solid var(--primary-bg);
    }
    ::-webkit-scrollbar-thumb:hover {
        background-color: var(--accent-hover);
    }
  }

  body {
    font-family: var(--font-primary);
    background-color: var(--primary-bg);
    color: var(--primary-text);
    line-height: 1.7;
    overflow-x: hidden;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  code {
    font-family: var(--font-code);
  }

  a {
    color: var(--accent-color);
    text-decoration: none;
    transition: color var(--transition-speed) var(--transition-effect);
  }

  a:hover {
    color: var(--accent-hover);
  }

  h1, h2, h3, h4, h5, h6 {
    color: var(--heading-text);
    font-weight: 600;
    line-height: 1.3;
    margin-bottom: 1rem;
    text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.3);
  }

  h1 { font-size: clamp(2.5rem, 5vw, 3.5rem); }
  h2 { font-size: clamp(2rem, 4vw, 2.5rem); }
  h3 { font-size: clamp(1.3rem, 3vw, 1.6rem); }
  p { margin-bottom: 1.2rem; color: var(--secondary-text); font-size: clamp(0.95rem, 1.5vw, 1.05rem); }

  img, video {
    max-width: 100%;
    height: auto;
    display: block;
    will-change: transform;
  }

  section {
    padding: 7rem 6%;
    overflow: hidden;
    position: relative;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  }

  section:last-of-type {
    border-bottom: none;
  }

  .btn {
    display: inline-block;
    padding: 1rem 2.5rem;
    background: var(--accent-color);
    color: var(--primary-bg);
    font-weight: 600;
    border-radius: var(--border-radius);
    transition: background var(--transition-speed) var(--transition-effect),
                color var(--transition-speed) var(--transition-effect),
                transform var(--transition-speed) var(--transition-effect),
                box-shadow var(--transition-speed) var(--transition-effect);
    border: 2px solid var(--accent-color);
    cursor: pointer;
    text-transform: uppercase;
    letter-spacing: 1.5px;
    margin-top: 1.5rem;
    box-shadow: 0 5px 15px rgba(0, 255, 204, 0.2);
  }

  .btn:hover {
    background: transparent;
    color: var(--accent-color);
    transform: translateY(-5px) scale(1.03);
    box-shadow: 0 10px 25px var(--strong-shadow-color);
  }

  .jarvis-text {
    font-family: var(--jarvis-font);
    color: var(--jarvis-primary);
    text-shadow: 0 0 10px var(--jarvis-glow);
    letter-spacing: 1px;
  }
  
  .jarvis-container {
    background: rgba(11, 5, 5, 0.4);
    backdrop-filter: blur(8px);
    border: 1px solid rgba(64, 224, 208, 0.2);
    box-shadow: 0 0 20px rgba(64, 224, 208, 0.1);
    border-radius: 8px;
    transition: all 0.3s ease;
    
    &:hover {
      border-color: rgba(64, 224, 208, 0.4);
      box-shadow: 0 0 30px rgba(64, 224, 208, 0.2);
    }
  }
  
  /* Jarvis-inspired scrollbar */
  ::-webkit-scrollbar {
    width: 8px;
    background: rgba(11, 5, 5, 0.2);
  }
  
  ::-webkit-scrollbar-thumb {
    background: linear-gradient(to bottom, rgba(64, 224, 208, 0.3), rgba(64, 224, 208, 0.6));
    border-radius: 4px;
    
    &:hover {
      background: linear-gradient(to bottom, rgba(64, 224, 208, 0.5), rgba(64, 224, 208, 0.8));
    }
  }
`;

export default GlobalStyles;